import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'math-equal-greater',
  'IconMathEqualGreater',
  [
    ['path', { d: 'M5 18l14 -4', key: 'svg-0' }],
    ['path', { d: 'M5 14l14 -4l-14 -4', key: 'svg-1' }],
  ],
);
